import React, { useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getMineSaleOrderList } from "../../../../redux/sale/action";
import { useEffect } from "react";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import { Commas, getDateFormate } from "../../../Common/AllDateTimeReleventFormate";
import useChatNavigation from "../../../Common/useChatNavigation";
import { getSaleStatusText } from "../../../Common/Status/Bxpstatus";
import { getMineActiveBXPList } from "../../../../redux/ots/action";
import GetRemainDays from "../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetRemainDays";
import GetStatus from "../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetStatus";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { decodeHtml } from "../../../../assests/extention/commonfunction";

export default function ActiveBXPListing() {
  const path = "Assets/scss/myorders.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);


  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { letChat } = useChatNavigation();


  const salelist = useSelector(({ ots: { mineactivebxplist } }) => mineactivebxplist);

  useEffect(() => {
    dispatch(getMineActiveBXPList(2));
  }, []);

  return (
    <>
      <div className="order-tabs">
        <div className="tab-content">
          <div className="posted-project">
            <div className="recent-post">
              {/* <h4>Purchase requests history ({salelist?.length || 0})</h4> */}
              {
                Array.isArray(salelist) && salelist?.length > 0 ?
                  <>
                    {salelist.map((item, index) => (
                      <div key={index} className="post-back">
                        <div className="col-md-5">
                          <h3>{decodeHtml(item.title)}</h3>
                          <div className="post-img">
                            <GetRemainDays
                              enddate={item?.active_milestone?.ends_on}
                            />
                          </div>
                        </div>
                        <div className="activity col-md-4">
                          <h6>Active milestone: {item?.active_milestone_count}</h6>
                          <h5>
                            {!item?.active_milestone?.title
                              ? "No Active Milestone"
                              : decodeHtml(item?.active_milestone?.title)}
                          </h5>

                          <GetStatus status={item?.active_milestone?.status} />
                        </div>
                        <button
                          onClick={() =>
                            navigate(
                              `/${lan}/dashboard/receivedorders/project/active/${item.id}`,
                            )
                          }
                          className="btn"
                        >
                          Review works
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                            alt=""
                          />
                        </button>
                      </div>
                    ))
                    }
                  </>
                  :
                  <PostNotFound title={"No Post Found"} height={200} />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
